import {useState, useMemo, useEffect} from 'react';
// @ts-ignore
import {TabMenuContext} from "./Globals.tsx";

export function TabMenu({tabs = [], children, onChange = null}){
  const [activeTab, setActiveTab] = useState<number>(0);
  const [actionP, setActionP] = useState(null);
  const [actionPText, setActionPText] = useState("Speichern");
  const context = useMemo(() => ({
    setActionP: (e) => setActionP(() => e),
    setActionPText: (e) => setActionPText(e)
  }), [actionP])

  useEffect(() => {
    if(onChange){
      onChange(activeTab, context, setActionPText)
    }
    else{
      setActionP(null)
    }
  }, [activeTab, setActionP, setActionPText]);

  return (<div className={"tab-menu-container"}>
    <div className={"tab-buttons"}>
      {tabs.map((tab, i) => <button className={"tab-button"} onClick={() => setActiveTab(i)}
                                    style={{
                                      color: activeTab === i ? "var(--accent)" : ""
                                    }}
      >
        {tab}
      </button>)}
    </div>
    <TabMenuContext.Provider value={context}>
      <div className={"tab_menu_content " + (actionP != null? "tab_menu_container_with_button": "")}>{children?.length > activeTab && children[activeTab]}</div>
    </TabMenuContext.Provider>
    {actionP != null &&
        <button className={"primarybutton tab-menu-button"} onClick={actionP}>
          {actionPText}
        </button>}

  </div>);
}